import { Balances } from './balances.model';
import { Entity } from './entity.model';

export class BalancesResponse {
    errorCode: number;
    errorDescription: string;
    errorMessage: string;
    response: {
        children: any;
        balances: Balances;
        entity: Entity,
        balancesList: Balances []
    };
    accountSummary: any;
}

export function naBalances(): BalancesResponse {
    return {
        errorCode: 0,
        errorDescription: '',
        errorMessage: '',
        response: {
            children: {},
            balances: {
                custodian: undefined,
                entity: {
                    id: undefined,
                    name: undefined,
                    context: undefined,
                    baseCurrency: undefined,
                    custodianCode: undefined,
                    accountCategory: undefined,
                    accountType: undefined,
                    quoteType: undefined
                },
                balancesSummary: {
                    totalWorth: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    fundsAvailableToWithdraw: undefined,
                    fundsAvailableToTrade: undefined,
                    fundsDue: undefined
                },
                balancesDetails: {
                    accountValue: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    longMarketValue: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    shortMarketValue: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    cashManagementBalance: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    openingBalance: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    todaysActivity: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    netBalance: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    totalAnnuityValue: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    securitiesOwed: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    liquidatingEquity: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    creditInterest: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    debitInterest: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    totalInsuranceValue: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    currentOpeningBalance: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    intraDayActivity: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    monthToDateEarnings: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    principalCash: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    incomeCash: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    cash: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    annuities: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    annuityFixedValAmt: undefined,
                    annuityVariableValAmt: undefined,
                    annuityPendingValAmt: undefined,
                    overallCashAvailable: undefined,
                    dayTradingBuyingPowerPrevClose: undefined,
                    cashAvailableCash: undefined,
                    cashAvailableMargin: undefined,
                    cashManagementAvailable: undefined,
                    pendingWithdrawals: undefined,
                    overallCashAvailablePrincipal: undefined,
                    cashAvailablePrincipal: undefined,
                    cashManagementAvailablePrincipal: undefined,
                    pendingWithdrawalsPrincipal: undefined,
                    overallCashAvailableIncome: undefined,
                    cashAvailableIncome: undefined,
                    cashManagementAvailableIncome: undefined,
                    pendingWithdrawalsIncome: undefined,
                    fundsUnavailable: undefined,
                    marginableEquity: undefined,
                    nonMarginableEquity: undefined,
                    longOptions: undefined,
                    convertibleBonds: undefined,
                    corporateBonds: undefined,
                    municipalBonds: undefined,
                    governmentBonds: undefined,
                    dayTradingBuyingPower: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    dayTradeMarginableEquity: undefined,
                    dayTradeNonMarginableEquity: undefined,
                    dayTradeLongOptions: undefined,
                    dayTradeConvertibleBonds: undefined,
                    dayTradeCorporateBonds: undefined,
                    dayTradeMunicipalBonds: undefined,
                    dayTradeGovernmentBonds: undefined,
                    prevSMA: undefined,
                    totalFederalCallSMA: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    smaChange: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    houseCall: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    finraCall: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    foreignCCYHouseReq: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    totalHouseReq: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    totalFinraReq: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    debitInterestRate: {
                        value: undefined,
                        difference: undefined,
                        percentChange: undefined
                    },
                    optionHouseReq: undefined,
                    securityHouseReq: undefined,
                    cashAccountSurplusUsed: undefined,
                    minimumEquityReq: undefined,
                    whenIssuedHouseReq: undefined,
                    foreignCCYList: undefined,
                    usdeCurrencyDetailList: undefined,
                    localCurrencyDetailList: undefined,
                    currencyDetailList: undefined,
                    taxReclaim: undefined,
                },
                childBalances: [],
                accountSummary: undefined,
                asOfDate: undefined,
                quoteType: undefined
            },
            balancesList:[],
            entity: {
                id: undefined,
                name: undefined,
                context: undefined,
                baseCurrency: undefined,
                custodianCode: 'PLLC',
                accountCategory: undefined,
                accountType: undefined,
                quoteType: undefined
            }
        },
        accountSummary: []
    };
}
